import { useInterval } from '../interval/use-interval';
import { useForceUpdate } from '../use-force-update/use-force-update';

export const useResendCooldown = (cooldownEndsAt: number | null) => {
  const forceUpdate = useForceUpdate();
  // eslint-disable-next-line react-x/purity -- countdown against a target timestamp is inherently time-dependent; forceUpdate on an interval keeps it ticking (matches useForceUpdatePeriod).
  const now = Date.now();
  const secondsRemaining = cooldownEndsAt
    ? Math.max(Math.ceil((cooldownEndsAt - now) / 1000), 0)
    : 0;

  useInterval(forceUpdate, secondsRemaining > 0 ? 1000 : null);

  return secondsRemaining;
};
